import { render, staticRenderFns } from "./fate-accelerated-custom.vue?vue&type=template&id=664d7b56&scoped=true&"
import script from "./fate-accelerated-custom.vue?vue&type=script&lang=js&"
export * from "./fate-accelerated-custom.vue?vue&type=script&lang=js&"
import style0 from "./fate-accelerated-custom.vue?vue&type=style&index=0&id=664d7b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d7b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664d7b56')) {
      api.createRecord('664d7b56', component.options)
    } else {
      api.reload('664d7b56', component.options)
    }
    module.hot.accept("./fate-accelerated-custom.vue?vue&type=template&id=664d7b56&scoped=true&", function () {
      api.rerender('664d7b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/fate-accelerated-custom.vue"
export default component.exports